import { EventEmitter } from 'events'

export const eventEmitter = new EventEmitter()
export const LOCAL_STORAGE_KEY = 'storageLastSeenProducts'
